rstools.compatibility = {
	mac: function () {
		return navigator.platform.indexOf('Mac') >= 0;
	}()
};